import React from "react";
import styled from "styled-components";

export const AssetWrapper = styled.div`
  background-color: ${({ theme: { colours } }) =>
    colours.statusBar.backgroundColor};
  color: ${({ theme: { colours } }) => colours.statusBar.color};
  z-index: 101;
  grid-area: asset;
  display: flex;
  grid: inherit;
  position: relative;
  padding-top: 16px;
  padding-left: 32px;
  .global-date-picker {
    margin-left: auto;
  }
`;
